angular.module('unica_campaign_template.campaign_template_services')

.factory('CampaignTemplateListService', function($http, getBaseApiURL) {

	var campaignTemplateListService = {};

	campaignTemplateListService.list = function (eventId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign-template/list/' + eventId,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign_templates;
			}

		});
	};

	campaignTemplateListService.get = function (campaignId)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/campaign-template/detail/' + campaignId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.campaign_template;
			}

		});

	};

	return campaignTemplateListService;

})
;